import { z } from 'zod';

const PROTOCOL_ID = z.guid();

/** A legacy `?expand=` (or the `/capture-stream` redirect's `?protocol=`)
 * protocol id, or null for an absent or malformed one. */
export function parseExpandParam(raw: string | null): string | null {
  return PROTOCOL_ID.safeParse(raw).success ? raw : null;
}
